import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { exchangeSession } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const params = new URLSearchParams(location.hash.replace(/^#/, ""));
    const session_id = params.get("session_id");
    if (!session_id) { navigate("/login", { replace: true }); return; }
    (async () => {
      try {
        const me = await exchangeSession(session_id);
        window.history.replaceState(null, "", "/admin");
        await refresh();
        if (!me.is_admin) {
          toast.error("This account is not authorized as an admin.");
          navigate("/", { replace: true });
        } else {
          navigate("/admin", { replace: true, state: { user: me } });
        }
      } catch {
        toast.error("Sign-in failed. Please try again.");
        navigate("/login", { replace: true });
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[var(--layor-ivory)]">
      <div className="text-center">
        <div className="font-display text-2xl text-[var(--layor-navy)]">Signing you in…</div>
        <div className="mt-2 text-sm text-[var(--layor-muted)]">One moment please.</div>
      </div>
    </div>
  );
}
